// Scripting for sliders or carousels (Baytek gutenblocks plugin includes a slider block that uses slick slider)
(function($){
	// Handle menu interactions
	$('.latest-news-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: true,
        // responsive: [
        //     {
        //         breakpoint: 780,
        //         settings: "unslick"
        //     }
        // ]
	});

	// Handle menu interactions
	$('.card-slider > .wp-block-group__inner-container').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 5000,
	});


	$('.left').click(function(){
	  $('.card-slider > .wp-block-group__inner-container').slick('slickPrev');
	})

	$('.right').click(function(){
	  $('.card-slider > .wp-block-group__inner-container').slick('slickNext');
	})


	// Handle menu interactions
	$('.gallery-slider > .blocks-gallery-grid').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 5000,
	});


	$('.left').click(function(){
	  $('.gallery-slider > .blocks-gallery-grid').slick('slickPrev');
	})

	$('.right').click(function(){
	  $('.gallery-slider > .blocks-gallery-grid').slick('slickNext');
	})


	// Handle menu interactions
	$('.supply-slider > .wp-block-group__inner-container').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 5000,
		adaptiveHeight: true
	});
	$('a[data-slide]').click(function(e) {
		e.preventDefault();
		var slideno = $(this).data('slide');
		$('.supply-slider > .wp-block-group__inner-container').slick('slickGoTo', slideno - 1);
	});
	$(".supply-action a").on( "click", function() {
	  $(".supply-action a").removeClass("active");
	  $(this).addClass("active");
	});

})(jQuery);


